export const sleep = (ms: number) => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(ms), ms);
  });
};

// 加载脚本
export function loadScript(url: string, callback?: () => void) {
  const script = document.createElement('script');
  script.onload = function() {
    callback?.();
  };
  script.src = url;
  document.head.appendChild(script);
}

export function isBauduApp() {
  const ua = navigator.userAgent.toLowerCase();
  return /\bbaidu/i.test(ua);
}

// 判断是否全面屏
export function judgeFullScreen() {
  const rate = window.screen.height / window.screen.width;
  const limit = window.screen.height === window.screen.availHeight ? 1.8 : 1.65;
  return rate > limit;
}// 设备打开类型
export const getSystem = function() {
  const userAgent = navigator.userAgent.toLowerCase();
  console.log(userAgent, 'userAgent');
  // heytap  OPPO   xiaomi  小米  huawei 华为

  // if (userAgent.match(/MicroMessenger/i)) {
  //   return 'wechat';// 微信
  // } else if (userAgent.match(/qq/i)) {
  //   return 'qq'; // QQ
  // } else
  if (userAgent.match(/(iPhone|iPod|iPad)/i)) {
    return 'ios'; // 苹果
  } else if (userAgent.match(/heytap/i)) {
    return 'heytap'; // OPPO
  } else if (userAgent.match(/xiaomi/i)) {
    return 'xiaomi'; // 小米
  } else if (userAgent.match(/huawei/i)) {
    return 'huawei'; // 华为
  } else if (userAgent.match(/vivo/i)) {
    return 'vivo'; // vivo
  }
};

export const isHuawei = () => {
  return getSystem() === 'huawei';
};
